import Swiper from "../../../../../../vendor/swiper/swiper-bundle.mjs";

export default class ProductDetailCarousel {
    constructor($element) {
        this.$element = $element;
        this.$swiper = this.$element.querySelector('.swiper');
        this.$pagination = this.$element.querySelector('.swiper-pagination');
        this.$next = this.$element.querySelector('.swiper-button-next');
        this.$prev = this.$element.querySelector('.swiper-button-prev');
        this.$slides = this.$element.querySelectorAll('.swiper-slide');
        this.swiper = null;

        if (!this.$swiper || this.$slides.length <= 1) {
            this.$element.classList.add('product-detail__carousel--static');
            return;
        }

        this.init();
    }

    init() {
        this.swiper = new Swiper(this.$swiper, {
            slidesPerView: 1,
            spaceBetween: 16,
            speed: 450,
            grabCursor: true,
            navigation: {
                nextEl: this.$next,
                prevEl: this.$prev,
            },
            pagination: {
                el: this.$pagination,
                clickable: true,
            },
        });
    }
}
